import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

const lazyWithRetry = (importFn: () => Promise<{ default: React.ComponentType }>) =>
  lazy(() =>
    importFn().catch(() => {
      window.location.reload();
      return importFn();
    })
  );

export const USER_REGISTRY_ROUTES: TApplicationRoute[] = [
  {
    id: 'user-registry',
    path: '/admin/user-registry',
    component: lazyWithRetry(() => import('./pages/user-registry-page')),
    layout: 'default',
    permissions: { scopes: [] },
    menu: {
      title: 'pages.admin.userRegistry.title',
    },
  },
];
